import React from 'react';

import { CustomRow } from 'src/presentation/components/forms/CustomRow';
import TextareaField from 'src/presentation/components/forms/TextareaField';
import { FIELD_MAPPER } from 'src/presentation/components/pages/threads/ThreadsConstants';
import {
  FirstColumn,
  SecondColumn,
  ThreadCustomerIdentityImage,
  ThreadSection,
} from 'src/presentation/components/pages/threads/ThreadsLayouts';

const CustomerIdentityAuthenticationSection = () => (
  <>
    <FirstColumn>
      <ThreadSection
        header="Customer Identity Authentication"
        description="Messages sent to verify the customer’s identity using their email address."
      >
        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CONFIRM_CUSTOMER_AUTH_CODE.label}
            description={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CONFIRM_CUSTOMER_AUTH_CODE.description}
            data-aid={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CONFIRM_CUSTOMER_AUTH_CODE.path}
            attr={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CONFIRM_CUSTOMER_AUTH_CODE.path}
            placeholder={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CONFIRM_CUSTOMER_AUTH_CODE.placeholder}
          />
        </CustomRow>

        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CORRECT_CODE_MESSAGE.label}
            description={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CORRECT_CODE_MESSAGE.description}
            data-aid={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CORRECT_CODE_MESSAGE.path}
            attr={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CORRECT_CODE_MESSAGE.path}
            placeholder={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_CORRECT_CODE_MESSAGE.placeholder}
          />
        </CustomRow>

        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_INCORRECT_CODE_MESSAGE.label}
            description={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_INCORRECT_CODE_MESSAGE.description}
            data-aid={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_INCORRECT_CODE_MESSAGE.path}
            attr={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_INCORRECT_CODE_MESSAGE.path}
            placeholder={FIELD_MAPPER.CUSTOMER_IDENTITY_AUTHENTICATION_INCORRECT_CODE_MESSAGE.placeholder}
          />
        </CustomRow>
      </ThreadSection>
    </FirstColumn>
    <SecondColumn>
      <ThreadCustomerIdentityImage />
    </SecondColumn>
  </>
);

export default CustomerIdentityAuthenticationSection;
